import { inject, Injectable } from '@angular/core';
import { PartnerInfoService as CmsPartnerInfoService } from '../../../core/cms-api/services/partner-info.service';
import { Observable } from 'rxjs';
import {
  Result,
  SubCpoBillingAndPlansResponseResult,
  SubCpoListResponseListResult,
  SubCpoOverviewDetailsResult,
  TariffMarginPerCategoryResponseResult,
} from '../../../core/cms-api/models';

@Injectable({
  providedIn: 'root',
})
export class PartnerInfoService {
  private apiParnterInfoService = inject(CmsPartnerInfoService);

  reinviteSubCpoToOnboarding(subCpoId: string): Observable<Result> {
    return this.apiParnterInfoService.partnerInfoReinviteToOnboardingSubOperatorIdPost(
      {
        subOperatorId: subCpoId,
      },
    );
  }

  blockSubCpo(subCpoId: string): Observable<Result> {
    return this.apiParnterInfoService.partnerInfoBlockPartnerSubCpoIdPost({
      subCpoId: subCpoId,
    });
  }

  subcpoOverviewDetails(
    subCpoId: string,
  ): Observable<SubCpoOverviewDetailsResult> {
    return this.apiParnterInfoService.partnerInfoOverviewDetailsSubCpoIdGet({
      subCpoId: subCpoId,
    });
  }

  subcpoBillingAndPlans(
    subCpoId: string,
  ): Observable<SubCpoBillingAndPlansResponseResult> {
    return this.apiParnterInfoService.partnerInfoBillingAndPlansSubCpoIdGet({
      subCpoId: subCpoId,
    });
  }

  getTariffMarginPerCategory(
    subCpoId: string,
  ): Observable<TariffMarginPerCategoryResponseResult> {
    return this.apiParnterInfoService.partnerInfoTariffMarginPerCategoryOperatorIdGet({
        operatorId: subCpoId,
    });
  }

  getSubCpoData(subCpoId: string): Observable<SubCpoListResponseListResult> {
    return this.apiParnterInfoService.partnerInfoGetSubcposSubCpoIdGet({
      subCpoId: subCpoId,
    });
  }
}
